import { ChangeDetectionStrategy, Component, HostListener, inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'lib-pegase-snack-bar-success',
    templateUrl: './snack-success.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIconModule, MatButton],
    standalone: true
})
@HostListener('mat-simple-snackbar')
export class SnackSuccessComponent {
    public snackBarRef = inject(MatSnackBarRef<SnackSuccessComponent>);
    public data = inject(MAT_SNACK_BAR_DATA);

    /**
     * Gestion de l'ouverture de la snackbar
     * @param snackBar la snackbar
     * @param message à afficher
     * @param duration en milsec (facultatif)
     * @param icon l'icône à afficher (facultatif)
     */
    public static open(
        snackBar: MatSnackBar,
        message: any,
        duration = 10000,
        icon = 'sentiment_satisfied_alt',
    ) {
        snackBar.openFromComponent(
            SnackSuccessComponent,
            {
                data: {matIcon: icon, message: message},
                announcementMessage: message,
                duration: duration,
                panelClass: 'success',
                verticalPosition: 'top',
            },
        );
    }
}
